import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiSupportIconCircleSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_38212_716)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			rx: 13,
			fill: "url(#paint0_linear_38212_716)"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_38212_716)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M12.4268 7.64151C12.4518 7.5077 12.5228 7.38684 12.6275 7.29987C12.7322 7.21289 12.8641 7.16528 13.0002 7.16528C13.1363 7.16528 13.2682 7.21289 13.3729 7.29987C13.4776 7.38684 13.5486 7.5077 13.5736 7.64151L14.1867 10.8837C14.2302 11.1142 14.3423 11.3262 14.5081 11.4921C14.674 11.658 14.886 11.77 15.1165 11.8135L18.3587 12.4266C18.4925 12.4516 18.6134 12.5226 18.7003 12.6273C18.7873 12.732 18.8349 12.8639 18.8349 13C18.8349 13.1361 18.7873 13.268 18.7003 13.3727C18.6134 13.4774 18.4925 13.5484 18.3587 13.5734L15.1165 14.1865C14.886 14.2301 14.674 14.3421 14.5081 14.5079C14.3423 14.6738 14.2302 14.8858 14.1867 15.1163L13.5736 18.3585C13.5486 18.4923 13.4776 18.6132 13.3729 18.7002C13.2682 18.7871 13.1363 18.8347 13.0002 18.8347C12.8641 18.8347 12.7322 18.7871 12.6275 18.7002C12.5228 18.6132 12.4518 18.4923 12.4268 18.3585L11.8137 15.1163C11.7702 14.8858 11.6581 14.6738 11.4923 14.5079C11.3264 14.3421 11.1144 14.2301 10.8839 14.1865L7.6417 13.5734C7.50788 13.5484 7.38702 13.4774 7.30005 13.3727C7.21308 13.268 7.16547 13.1361 7.16547 13C7.16547 12.8639 7.21308 12.732 7.30005 12.6273C7.38702 12.5226 7.50788 12.4516 7.6417 12.4266L10.8839 11.8135C11.1144 11.77 11.3264 11.658 11.4923 11.4921C11.6581 11.3262 11.7702 11.1142 11.8137 10.8837L12.4268 7.64151Z",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.6668 7.16663V9.49996",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.8333 8.33331H16.5",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.33329 18.8333C8.97762 18.8333 9.49996 18.311 9.49996 17.6667C9.49996 17.0223 8.97762 16.5 8.33329 16.5C7.68896 16.5 7.16663 17.0223 7.16663 17.6667C7.16663 18.311 7.68896 18.8333 8.33329 18.8333Z",
					stroke: "white",
					strokeWidth: 1.16667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_38212_716",
			x1: 13,
			y1: 0,
			x2: 13,
			y2: 26,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7C3AED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A855F7"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_38212_716",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 26,
				height: 26,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_38212_716",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14,
				fill: "white",
				transform: "translate(6 6)"
			})
		})
	] })]
});
export default SvgAiSupportIconCircleSmall;
